<template>
  <s-drawer
    :title="$i18n('Support Panel')"
    v-model="show"
    :append-to-body="true"
    style="position: absolute"
    class="switch-panel"
    :size="width"
  >
    <SIconChevronRight
      v-if="width === 700"
      @click="handleMinimizeScreen"
      class="support-panel-fullscreen-icon"
    />
    <SIconChevronLeft
      v-else
      @click="handleFullscreen"
      class="support-panel-fullscreen-icon"
    />
    <s-tabs v-model="activeTab" type="line" @tab-click="handleTabClick">
      <s-tabs-pane
        name="Configuration"
        :label="this.$i18n('Configuration Panel')"
      >
        <ConfPanel />
      </s-tabs-pane>
      <s-tabs-pane name="Permission" :label="this.$i18n('Permission Panel')">
        <PermissionPanel />
      </s-tabs-pane>
    </s-tabs>
  </s-drawer>
</template>
<script lang="ts">
import { reportEvent } from '@/utils/qms';
import { Component, ModelSync, Vue } from 'vue-property-decorator';
import ConfPanel from './conf-panel.vue';
import PermissionPanel from './permission-panel.vue';
@Component({
  components: {
    ConfPanel,
    PermissionPanel,
  },
})
export default class SwitchPanel extends Vue {
  @ModelSync('value', 'change', { type: Boolean }) show!: boolean;
  activeTab = 'Configuration';

  width = 700;

  handleTabClick() {
    const key =
      this.activeTab === 'Configuration'
        ? 'click_support_panel_configuration_tab'
        : 'click_support_panel_permission_tab';
    reportEvent(key);
  }

  handleMinimizeScreen() {
    this.width = 1;
  }

  handleFullscreen() {
    this.width = 700;
  }
}
</script>

<style lang="scss" scoped>
.switch-panel {
  ::v-deep .ssc-drawer {
    .ssc-drawer-header {
      border-bottom: none;
    }

    .ssc-drawer-body {
      padding: 0 24px;
    }
  }
}
</style>

<style lang="scss">
.g-permission-highlight {
  z-index: 9999;
  outline: 2px solid #ff4d4f;
  outline-offset: 2px;
}

.support-panel-fullscreen-icon {
  position: absolute;
  left: -1px;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #999999;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}
</style>
